import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_6: FaireProductEntity = {
  token: "atc_refined_moma_6",
  type: "product",
  name: "Contemporary Serving Plates",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/43c1d3133b391fc4264dbade7ee569fb02586b600d05708ae7d0c312fa64bc98.webp",
  priceDollars: 45,
  msrpDollars: 72,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
